import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Users, Tag, Percent, FileText, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/brands", label: "Brands", icon: Tag },
  { to: "/admin/discounts", label: "Discounts", icon: Percent },
  { to: "/admin/content", label: "Site Content", icon: FileText },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen flex bg-bone">
      <aside className="w-60 bg-[#141312] text-linen flex flex-col fixed h-screen">
        <Link to="/" className="px-6 h-20 flex items-center border-b border-white/10">
          <span className="font-serif text-xl tracking-[0.28em] text-ivory">LUXYREIGN</span>
        </Link>
        <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${isActive ? "bg-white/10 text-ivory" : "text-linen/60 hover:text-ivory hover:bg-white/5"}`}>
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <Link to="/" className="flex items-center gap-3 px-4 py-2.5 text-sm text-linen/60 hover:text-ivory"><ExternalLink className="w-4 h-4" /> View Store</Link>
          <button onClick={doLogout} data-testid="admin-logout" className="flex items-center gap-3 px-4 py-2.5 text-sm text-linen/60 hover:text-ivory w-full"><LogOut className="w-4 h-4" /> Sign Out</button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-h-screen">
        <header className="h-20 bg-ivory border-b border-linen flex items-center justify-between px-8 sticky top-0 z-20">
          <span className="eyebrow">Administrator Console</span>
          <span className="text-sm text-stonemuted">{user?.email}</span>
        </header>
        <div className="p-8"><Outlet /></div>
      </main>
    </div>
  );
}
